import { Component, inject } from '@angular/core';
import {switchMap, take} from 'rxjs/operators';
import {CsatService} from "@core";
import {IssueReportService} from "./service/issue-report.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ProblemInstanceService} from "planner-shared";
import {IssueReport} from "./models/issue-report.model";
import {NotificationService} from "@shared";

@Component({
    selector: 'app-issue-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    standalone: false
})
export class ReportComponent {
    private readonly csatService = inject(CsatService);
    private readonly issueReportService = inject(IssueReportService);
    private readonly problemInstanceService = inject(ProblemInstanceService);
    private readonly fb = inject(FormBuilder);
    private readonly notificationService = inject(NotificationService);


    public reportForm: FormGroup;
    public disabled = true;

    constructor() {
        this.reportForm = this.fb.group({
            content: ['', Validators.required]
        });
    }

    public dismissModal() {
        this.csatService.enableCsat(false);
    }

    public sendIssueFeedback() {
        const issueReport: IssueReport = { content: this.reportForm.controls.content.value, jobId: null};
        this.problemInstanceService.getProblemInstance()
            .pipe(
                take(1),
                switchMap(instanceResult => {
                    if (instanceResult.problemInstance.jobId) {
                        issueReport.jobId = instanceResult.problemInstance.jobId;
                    }
                    return this.issueReportService.sendIssueReport(issueReport);
                })
            )
            .subscribe({
                next: () => {
                    this.notificationService.success("ISSUE_REPORT_SENT_SUCCESS");
                    this.dismissModal();
                },
                error: () => {
                    this.notificationService.error("ISSUE_REPORT_SENT_ERROR");
                    this.dismissModal();
                }
            });
    }
}
